<template>
  <v-app :class="{ 'app--welcome': isWelcome }">
    <template v-if="authStore.isAuthReady && showAppChrome">
      <component :is="authStore.isSignedIn ? 'NavBarUser' : 'NavBar'" />
    </template>
    <v-main>
      <router-view></router-view>
      <Footer v-if="showFooter" />
    </v-main>
  </v-app>
</template>

<script>
import Footer from './components/Utils/FooterComp.vue'
import NavBar from './components/Utils/NavComp.vue'
import NavBarUser from './components/Utils/NavBarUser.vue'
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/store/auth_store';
import { useThemeStore } from '@/store/theme_store';

export default {
  name: 'App',

  components: {
    Footer,
    NavBar,
    NavBarUser
  },

  setup() {
    const authStore = useAuthStore();
    const themeStore = useThemeStore();
    const route = useRoute();
    const showAppChrome = computed(() => !route.meta.hideAppChrome);
    const isWelcome = computed(() => route.name === 'welcome');
    const showFooter = computed(() => !authStore.isSignedIn && isWelcome.value);

    onMounted(() => {
      authStore.initAuth();
      themeStore.initTheme();
    });

    return {
      authStore,
      themeStore,
      isWelcome,
      showAppChrome,
      showFooter,
    };
  },
};
</script>

<style>
  @import "@/assets/css/global_style.css";

  .app--welcome {
    background: linear-gradient(
      180deg,
      #b9d2ea 0%,
      #d4e1f0 35%,
      #efe8e1 55%,
      #d4e1f0 75%,
      #b9d2ea 100%
    );
  }

  .app--welcome .v-application__wrap,
  .app--welcome .v-main {
    background: transparent;
  }

</style>
